import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import areAllPropertiesNonEmpty from 'src/compass/shared/util/areAllPropertiesNonEmpty';
import {
  CasRadioGroup,
  CasRHFPercentField,
} from 'src/compass/shared/components';
import { CasAsOfMultiRowTable } from 'src/compass/application/commissions';
import { CasRHFRiskManagerSelect } from 'src/compass/application/general/components/CasRiskManagerSelect';

export enum CommissonAdjustmentRadioGroup {
  NoAdjustment = 'NoAdjustment',
  Year1Adjustments = 'Year1Adjustments',
  SplitWithOtherBrokers = 'SplitWithOtherBrokers',
}

interface ICommissionAdjustment {
  selectedEmployee?: string;
  asofReadonly: boolean;
}

export default function CommissionAdjustment({
  selectedEmployee,
  asofReadonly,
}: ICommissionAdjustment) {
  const { trigger } = useFormContext();

  const asOfSplitsDataWithBroker = useWatch({
    name: ['asOf.asOfSplits', 'asOf.totalRatePercent', 'servicingBrokerId'],
  });

  useEffect(() => {
    if (asOfSplitsDataWithBroker[0] && areAllPropertiesNonEmpty(asOfSplitsDataWithBroker[0])) {
      trigger('asOf.asOfSplits');
    }
  }, [asOfSplitsDataWithBroker, trigger]);

  const options = [
    {
      value: CommissonAdjustmentRadioGroup.NoAdjustment,
      label: 'No Adjustment',
    },
    {
      value: CommissonAdjustmentRadioGroup.Year1Adjustments,
      label: 'Year1 adjustment',
      propertyNameToClear: 'asOf.year1BrokerRate',
      component: (
        <CasRHFPercentField name="asOf.year1BrokerRate" label="Year1 Rate" disabled={asofReadonly} />
      ),
    },
    {
      value: CommissonAdjustmentRadioGroup.SplitWithOtherBrokers,
      label: 'Split with other brokers?',
      propertyNameToClear: 'asOf.asOfSplits',
      component: (
        <CasAsOfMultiRowTable
          readOnly={asofReadonly}
          name="asOf.asOfSplits"
          row1Cell1={selectedEmployee}
          rowCountMode={2}
          columns={[
            {
              type: 'component',
              label: 'Broker',
              name: 'brokerId',
              fullWidth: true,
              component: CasRHFRiskManagerSelect,
            },
            {
              type: 'component',
              label: 'Rate',
              name: 'ratePercent',
              component: CasRHFPercentField,
            },
          ]}
        />
      ),
    },
  ];

  return (
    <CasRadioGroup
      name="asOf.adjustmentType"
      disabled={asofReadonly}
      label=""
      spacing={2}
      options={options}
    />
  );
}
